module.exports = __webpack_public_path__ + "1ded50a49d8f96bf9bfe5a0b4afe1b5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/images/tutorial/1.png
// module id = 1611
// module chunks = 0